import { formatNumber } from "@borealis/number-format";
import type { NMPLocale } from "@borealis/locale-common";

export function largeNumberFormatter(value: number | string, locale: NMPLocale) {
    if (value === "") {
        return value;
    }

    const intValue = typeof value === "string" ? parseInt(value, 10) : value;

    return formatNumber(intValue, locale);
}
